export const HOMESTEAD_SERIES_EPISODE_1_ID = 'dee2b65a-ccaa-437b-810d-bbd36bcfd98f'
export const HOMESTEAD_FILM_SERIES_EPISODE_1_ID = 'bd55ec65-66d1-4a47-a80b-35e26aae2430'
